module.exports = __webpack_public_path__ + "static/img/teaching.01d5681f.png";